(() => {
  // === Configuration constants ===
  const MODAL_SELECTOR = '[data-filter-modal="__sort"]';
  const ITEM_SELECTOR = '[data-sort]';
  const ACTIVE_CLASS = 'active';

  /**
   * Binds click listeners to sort items inside the modal.
   * Applies a visual "active" state when an item is clicked.
   */
  const bindSortListeners = (modal) => {
    if (!modal || modal.dataset.sortBound === 'true') return; // prevent duplicate bindings
    modal.dataset.sortBound = 'true';

    modal.addEventListener('click', (e) => {
      const el = e.target.closest(ITEM_SELECTOR);
      if (!el) return;

      e.preventDefault();

      // Update active class on all sort options
      const items = modal.querySelectorAll(ITEM_SELECTOR);
      for (const item of items) {
        const li = item.closest('li');
        li?.classList.toggle(ACTIVE_CLASS, item === el);
      }
    });
  };

  /**
   * Watches for the modal to appear in the DOM.
   * Handles both static and dynamically inserted modals.
   */
  const observeModal = () => {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (modal) return bindSortListeners(modal);

    // If the modal is dynamically rendered, watch for its insertion
    const observer = new MutationObserver((mutations, obs) => {
      const newModal = document.querySelector(MODAL_SELECTOR);
      if (newModal) {
        bindSortListeners(newModal);
        obs.disconnect(); // stop observing once found
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // === Initialize ===
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModal);
  } else {
    observeModal();
  }
})();
